<template>
    <div>
        <v-card height="100%">
            <v-banner sticky color="white" class="pt-1 pb-1" single-line>
                <v-card-title class="text-h5 pt-0 pb-0 pl-0">
                    <v-btn
                        class="mr-3"
                        depressed
                        color="primary"
                        icon
                        rounded
                        @click="closeDialogVersions"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                    {{ quote.name }}
                </v-card-title>
            </v-banner>
            <v-card-text>
                <v-row no-gutters class="mt-3">
                    <v-col cols="2" class="d-flex">
                        <p class="mr-2 text-subtitle-1 font-weight-black">
                            Scope:
                        </p>
                    </v-col>
                    <v-col cols="10" class="d-flex  flex-wrap">
                        <p
                            style="margin-top: 5px; font-size: medium; font-weight: 500;"
                        >
                            {{ costInfo.reference }}
                        </p>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2" class="d-flex">
                        <p class="mr-2 text-subtitle-1 font-weight-black">
                            Scope Type:
                        </p>
                    </v-col>
                    <v-col cols="10" class="d-flex  flex-wrap">
                        <p
                            style="margin-top: 5px; font-size: medium; font-weight: 500;"
                        >
                            {{ costInfo.category }}
                        </p>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headersCosts"
                    class="elevation-0 mt-1"
                    :items="items"
                    hide-default-footer
                    :mobile-breakpoint="0"
                    :disable-pagination="true"
                >
                    <template v-slot:[`item.versionNumber`]="{ item }">
                        <p class="my-0 text-capitalize">
                            {{ item.versionNumber }}
                        </p>
                    </template>
                    <template v-slot:[`item.generatedOn`]="{ item }">
                        {{ formatDate2(item.generatedOn) }}
                    </template>
                    <template v-slot:[`item.engineer`]="{ item }">
                        {{ getUserName(item.engineer) }}
                    </template>
                    <template v-slot:[`item.rejectedOn`]="{ item }">
                        {{ formatDate2(item.rejectedOn) }}
                    </template>
                    <template v-slot:[`item.rejectionReason`]="{ item }">
                        {{ item.rejectionReason }}
                    </template>
                    <template v-slot:[`item.rejectionNotes`]="{ item }">
                        <v-btn
                            v-if="
                                (item.rejectionAttachments &&
                                    item.rejectionAttachments.length > 0) ||
                                    (item.rejectionImages &&
                                        item.rejectionImages > 0) ||
                                    item.rejectionNotes
                            "
                            icon
                            small
                            depressed
                            class="ml-2"
                            @click="openRejectionNotes(item)"
                        >
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <v-btn
                            color="transparent"
                            elevation="0"
                            small
                            class="ma-1 text-capitalize text--darken-2  pa-2"
                            @click.stop="openFile(item.name ? item.name : '')"
                        >
                            <span
                                style="font-size: 11px; color: #2b81d6; text-decoration: underline; cursor: pointer;"
                                >{{
                                    item.versionNumber
                                        ? `V${item.versionNumber}`
                                        : ''
                                }}</span
                            >
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="rejectPreDesignDialog"
            persistent
            max-width="600px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="rejectPreDesignDialog">
                <v-card-title v-if="rejectPreDesignDialog" class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeRejectPreDesignDialog"
                        color="primary"
                        class="mr-2"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    Pre-Design rejection notes</v-card-title
                >
                <v-card-text>
                    <strong>Notes:</strong>
                    <div class="mt-4 mb-5">
                        <vue-editor
                            ref="editor"
                            class="mt-2"
                            :editor-options="{
                                modules: {
                                    toolbar: false,
                                },
                            }"
                            :disabled="true"
                            v-model="editorContent"
                        />
                    </div>
                    <strong>Attachments: </strong>
                    <div class="d-flex align-center flex-wrap mt-4">
                        <div v-for="(file, i) in files" :key="i" class="d-flex">
                            <v-card
                                class="d-flex ma-0 ml-2 pa-1 mb-4"
                                @click="openFileAttached(file)"
                                :style="{ position: 'relative' }"
                            >
                                <v-img
                                    class="mb-2 pb-2"
                                    max-width="100px"
                                    max-height="100px"
                                    :src="
                                        file.pdfPreview
                                            ? file.pdfPreview
                                            : file.url
                                    "
                                >
                                </v-img>
                            </v-card>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions> </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { storage } from '@/services/firebase'
import { VueEditor } from 'vue2-editor'
import { loadPDFPreview } from '@/components/Nomina/ReportNomina.js'

export default {
    name: 'RejectionTable',
    components: {
        VueEditor,
    },
    props: {
        quote: {
            type: Object,
            required: true,
            default: () => {},
        },
        costInfo: {
            type: Object,
            required: true,
            default: () => {},
        },
        companyId: {
            type: String,
            required: true,
            default: () => '',
        },
        quoteId: {
            type: String,
            required: true,
            default: () => '',
        },
        costId: {
            type: String,
            required: true,
            default: () => '',
        },
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        users: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        headersCosts: [
            {
                text: 'VERSION',
                value: 'versionNumber',
                class: 'grey lighten-3',
                width: 10,
            },
            {
                text: 'DATE SENT',
                value: 'generatedOn',
                class: 'grey lighten-3',
                sortable: false,
                width: 30,
            },
            {
                text: 'ENGINEER',
                value: 'engineer',
                class: 'grey lighten-3',
                sortable: false,
                width: 30,
            },
            {
                text: 'DATE REJECTED',
                value: 'rejectedOn',
                class: 'grey lighten-3',
                sortable: false,
                width: 30,
            },
            {
                text: 'REASON FOR REJECTION',
                value: 'rejectionReason',
                class: 'grey lighten-3',
                sortable: false,
                width: 190,
            },
            {
                text: 'REJECTION NOTES',
                value: 'rejectionNotes',
                class: 'grey lighten-3',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'FILE',
                value: 'name',
                class: 'grey lighten-3',
                align: 'center',
                sortable: false,
                width: 10,
            },
        ],
        editorContent: '',
        imagesOnBase64: [],
        imagesWithDimensions: [],
        imagesAsFiles: [],
        originalImages: [],
        selectedItem: {},
        rejectPreDesignDialog: false,
        loading: false,
        files: [],
    }),
    watch: {
        editorContent: async function() {
            this.imagesOnBase64 = this.extractImagesWithMatchAll(
                this.editorContent
            )
        },
        imagesOnBase64: async function(newImages) {
            if (!newImages || newImages.length === 0) return
            try {
                const imagesWithDimensions = await this.getImagesDimensions(
                    newImages
                )
                const filesArray = await this.convertToFiles(
                    imagesWithDimensions
                )
                this.imagesWithDimensions = imagesWithDimensions
                this.imagesAsFiles = filesArray
            } catch (error) {
                console.error('An error has occurred.', error)
            }
        },
    },
    methods: {
        formatDate(date) {
            return moment
                .unix(date.seconds || date._seconds)
                .format('YYYY-MM-DD')
        },
        formatDate2(date) {
            if (!date) return ''

            if (typeof date === 'object' && (date._seconds || date.seconds)) {
                return moment
                    .unix(date._seconds || date.seconds)
                    .format('YYYY-MM-DD')
            } else if (
                typeof date === 'string' &&
                moment(date, moment.ISO_8601, true).isValid()
            ) {
                return moment(date).format('YYYY-MM-DD')
            } else {
                console.warn('Invalid date format:', date)
                return ''
            }
        },
        extractImagesWithMatchAll(htmlContent) {
            const regex = /<img\s+[^>]*src="([^"]+)"(?:[^>]*data-name="([^"]+)")?[^>]*>/g

            // Convertir las coincidencias en un arreglo
            const extractedImages = Array.from(htmlContent.matchAll(regex)).map(
                match => ({
                    base64: match[1], // Contenido Base64
                    name: match[2] || null, // Mantener null si no tiene data-name
                })
            )
            return extractedImages
        },
        async getImagesDimensions(base64Images) {
            return Promise.all(
                base64Images.map(image => {
                    return new Promise((resolve, reject) => {
                        const img = new Image()
                        img.onload = () => {
                            resolve({
                                src: image.base64,
                                name: image.name,
                                width: img.width,
                                height: img.height,
                            })
                        }
                        img.onerror = () => {
                            reject(
                                `Error loading base64 image: ${image.base64}`
                            )
                        }
                        img.src = image.base64
                    })
                })
            )
        },
        async convertToFiles(imagesWithDimensions) {
            return Promise.all(
                imagesWithDimensions.map(async imageObj => {
                    const { src, width, height, name } = imageObj
                    const file = await this.base64ToFile(src, name)
                    const url = URL.createObjectURL(file)
                    return { src: file, width, height, url, base64: src, name }
                })
            )
        },
        base64ToFile(base64, originalName = null) {
            return new Promise(resolve => {
                const byteString = Uint8Array.from(
                    atob(base64.split(',')[1]),
                    c => c.charCodeAt(0)
                )
                const mimeString = base64
                    .split(',')[0]
                    .split(':')[1]
                    .split(';')[0]

                // Use original name (UUID) if provided, otherwise generate new UUID
                const fileName = originalName || uuidv4()
                const blob = new Blob([byteString], { type: mimeString })
                const file = this.blobToFile(blob, fileName)
                resolve(file)
            })
        },
        blobToFile(blob, fileName) {
            return new File([blob], fileName, {
                type: blob.type,
                lastModified: new Date().getTime(),
            })
        },
        async openRejectionNotes(item) {
            this.selectedItem = item
            let attachments = []
            if (
                item.rejectionAttachments &&
                item.rejectionAttachments.length > 0
            ) {
                for (const doc of item.rejectionAttachments) {
                    const storageRef = storage().ref(
                        `${this.companyId}/quotes/${this.quoteId}/costs/${this.costId}/preDesigns`
                    )
                    if (doc.newFile || doc.url) {
                        attachments.push(doc)
                        continue
                    }
                    const documentRef = storageRef.child(doc)
                    await documentRef
                        .getDownloadURL()
                        .then(response => {
                            attachments.push({
                                name: doc,
                                url: response,
                            })
                        })
                        .catch(() => {
                            attachments.push({
                                name: doc,
                                url: '',
                            })
                        })
                }
                for (const file of attachments) {
                    if (file.name.includes('.pdf')) {
                        file.pdfPreview = await loadPDFPreview(file.url)
                    }
                }
            }
            this.files = attachments
            if (item.rejectionNotes) {
                const contentFromTxt = await this.loadEditorContentFromTxt(
                    item.rejectionNotes
                )
                this.editorContent = contentFromTxt || '<p></p>'
            } else if (item.rejectionImages && item.rejectionImages > 0) {
                await this.migrateLegacyImagesToEditor()
            } else {
                this.editorContent = '<p></p>'
            }
            this.rejectPreDesignDialog = true
        },
        closeRejectPreDesignDialog() {
            this.rejectPreDesignDialog = false
            this.editorContent = ''
            this.imagesOnBase64 = []
            this.imagesWithDimensions = []
            this.imagesAsFiles = []
            this.originalImages = []
            this.selectedItem = {}
        },
        async loadEditorContentFromTxt(fileName) {
            try {
                const path = `${this.companyId}/quotes/${this.quoteId}/costs/${this.costId}/preDesigns`
                const storageRef = storage().ref(path)
                const txtRef = storageRef.child(fileName)

                // Get download URL
                const url = await txtRef.getDownloadURL()

                // Fetch the content
                const response = await fetch(url)
                const content = await response.text()
                return content
            } catch (error) {
                // Don't show error to user as this is optional (fallback to Firestore)
                return null
            }
        },
        async migrateLegacyImagesToEditor() {
            try {
                // Wait for all images to load their base64 data
                await this.loadImages()
                // Generate HTML content from legacy images and update image references
                let htmlContent = '<p>'
                const updatedImages = []

                this.selectedItem.rejectionImages.forEach((img, index) => {
                    if (img && img.base64) {
                        // Use original name if it exists, otherwise generate UUID
                        const imageName = img.name || uuidv4()
                        htmlContent += `<img src="${img.base64}" data-name="${imageName}" alt="${imageName}"/>`

                        // Keep the original name or use the generated one
                        updatedImages.push({
                            name: imageName,
                            index: index,
                        })
                    }
                })
                htmlContent += '</p>'

                // Set the editor content
                this.editorContent = htmlContent

                // Update the images array with new UUIDs
                this.selectedItem.rejectionImages = updatedImages
            } catch (error) {
                this.editorContent = '<p></p>'
            }
        },
        async loadImages() {
            try {
                if (this.selectedItem.rejectionImages) {
                    for (let img of this.selectedItem.rejectionImages) {
                        if (img) {
                            if (!img.name) {
                                continue
                            }

                            const path = `${this.companyId}/quotes/${this.quoteId}/costs/${this.costId}/preDesigns`
                            const storageRef = storage().ref(path)
                            const docRef = storageRef.child(img.name)

                            let url
                            await docRef
                                .getDownloadURL()
                                .then(response => {
                                    url = response
                                })
                                .catch(error => {
                                    console.log(error)
                                    url = ''
                                })

                            await this.toDataUrl(img, url)
                        }
                    }
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        toDataUrl(img, url) {
            return new Promise((resolve, reject) => {
                var xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = () => {
                    var reader = new FileReader()
                    reader.onloadend = () => {
                        if (reader.result) {
                            this.handleLoadBlob(img, reader.result)
                            resolve(reader.result)
                        } else {
                            reject('No result from FileReader')
                        }
                    }
                    reader.onerror = () => {
                        reject('FileReader error')
                    }
                    reader.readAsDataURL(xhr.response)
                }
                xhr.onerror = () => {
                    reject('XMLHttpRequest error')
                }
                xhr.open('GET', url)
                xhr.send()
            })
        },
        close() {
            this.$emit('closeDialog')
        },
        closeDialogVersions() {
            this.$emit('closeDialogVersions')
        },
        openFile(itemName) {
            this.$emit('openFile', itemName)
        },
        openFileAttached(file) {
            window.open(file.url, '_blank')
        },
        getUserName(id) {
            if (this.users.length > 0 && id) {
                return this.users.find(user => user.id == id)?.name
            } else {
                return ''
            }
        },
    },
}
</script>

<style>
.v-data-table__wrapper {
    max-height: 50vh;
    overflow-y: auto;
}

.v-data-table__row {
    height: 64px;
}

.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
</style>
